<template>
	<div class="assistant-card">
		<div class="assistant-card-title">
			{{ card.totalCount }} {{ card.totalCount === 1 ? "product matches" : "products match" }}
			<span v-if="card.note" class="assistant-card-note">(first page shown)</span>
		</div>
		<div v-if="chips.length" class="assistant-chips">
			<v-chip v-for="chip in chips" :key="chip" x-small class="mr-1 mb-1" outlined>{{ chip }}</v-chip>
		</div>
		<v-btn small text color="primary" class="assistant-card-action" @click="$emit('apply', card)">
			<v-icon small class="mr-1" aria-hidden="true">mdi-magnify</v-icon>
			{{ onProductSearch ? "Apply to form" : "Show in search" }}
		</v-btn>
	</div>
</template>

<script>
import { describeFilters } from "@/utils/assistantFilters";

export default {
	name: "SearchCard",
	props: { card: { type: Object, required: true }, onProductSearch: { type: Boolean, default: false } },
	computed: {
		chips() {
			return describeFilters(this.card.filters);
		},
	},
};
</script>
